export default __webpack_public_path__ + "static/media/controller.72fa7391.mp4";